module.exports = __webpack_public_path__ + "img/behindthebar.832ffbd2.jpg";